import { actionTypes } from '../common/constants';

export const updateSettings = settings => dispatch => {
  return dispatch({
    type: actionTypes.UPDATE_SETTINGS,
    settings
  });
};

export const initStoreAction = state => dispatch => {
  return dispatch({
    type: actionTypes.INIT_STORE,
    state
  });
};

export const mergeStoreAction = state => dispatch => {
  return dispatch({
    type: actionTypes.MERGE_STORE,
    state
  });
};

export const updateFilter = (name, value) => dispatch => {
  return dispatch({
    type: actionTypes.UPDATE_FILTER,
    name,
    value
  });
};

export const clearAll = () => dispatch => {
  return dispatch({
    type: actionTypes.CLEAR_FILTERS,
    clear: true
  });
};

export const updatePage = page => dispatch => {
  return dispatch({
    type: actionTypes.UPDATE_PAGE,
    page
  });
};

export const updateSort = value => dispatch => {
  return dispatch({
    type: actionTypes.UPDATE_SORT,
    value
  });
};

export const updateResults = results => dispatch => {
  return dispatch({
    type: actionTypes.UPDATE_RESULTS,
    results
  });
};

export const updateStatus = status => dispatch => {
  return dispatch({
    type: actionTypes.UPDATE_STATUS,
    status
  });
};
